import type { RouteRecordRaw } from 'vue-router'
import { ROUTES } from '@/router/routes.enum'
import { ACTION_ROLES } from '@/utils/constants'
import { requireAuthenticatedUser } from '@/router/guards'

export const qrCodeRoutes: RouteRecordRaw[] = [
  {
    path: '/qr_codes',
    name: ROUTES.QR_CODES,
    component: () => import('@/modules/qr-codes/views/QrCodes.view.vue'),
    beforeEnter: requireAuthenticatedUser,
    meta: { roles: ACTION_ROLES.QR_CODES_VIEW }
  }
]
